import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { DestroyBase } from 'src/app/components/common/ng-destroy-base';
import { RaciTemplateOverviewModel } from '../../../models/raci-template-model-overview';
import { RaciTemplateService } from '../../../services/raci-template-service';

/**
 * Handles raci template search area component
 */
@Component({
  selector: 'raci-template-search-area',
  templateUrl: './raci-template-search-area.component.html',
  styleUrls: ['./raci-template-search-area.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RaciTemplateSearchAreaComponent extends DestroyBase implements OnInit {
  /**
   * Search model
   */
  searchModel = new RaciTemplateOverviewModel();

  /**
   * Search settings event emitter
   */
  @Output() search: EventEmitter<RaciTemplateOverviewModel> = new EventEmitter();

  /**
   * The name field
   */
  @ViewChild('nameField') nameField: TextBoxComponent;

  /**
   * Constructor
   * @param cmService RaciTemplateService
   * @param ref ChangeDetectorRef
   */
  constructor(private rtService: RaciTemplateService, private ref: ChangeDetectorRef) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.searchModel.name = '';

    this.subscriptions.add(this.rtService.resetSearch$.subscribe(() => {
      if (this.nameField) {
        this.nameField.clearValue();
      }
      this.clearSearch();
    }));
  }

  /**
   * Triggers the search
   */
  triggerSearch() {
    this.search.emit(this.searchModel);
  }

  /**
   * Clears the search
   */
  clearSearch() {
    this.searchModel = new RaciTemplateOverviewModel();
    this.searchModel.name = '';
    this.ref.markForCheck();
    this.triggerSearch();
  }
}
